<img src="../../assets/img/{{themeService.theme}}/how-works.svg" alt="Section Logo" width="170px">
<div class="title">Deleted items</div>
<p>Deleted items keeps a record of all the items deleted from your plan.</p>
<p>With one click you can restore a deleted item and add it back into your plan.</p>
<p>Alternatively, you can permanently delete an item - this will remove it from your deleted
    items page, meaning that it cannot be added back into your plan.
</p>